module.exports = __webpack_public_path__ + "img/ba3dd65f-8ee6-4782-b9f4-526cc6c8e8a6.77652d64.jpg";